import { render } from "./gallerySliderComponent.vue?vue&type=template&id=49fe803b&scoped=true"
import script from "./gallerySliderComponent.vue?vue&type=script&lang=js"
export * from "./gallerySliderComponent.vue?vue&type=script&lang=js"

import "./gallerySliderComponent.vue?vue&type=style&index=0&id=49fe803b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49fe803b"]])

export default __exports__